export default "__VITE_ASSET__9c4d2686__"